import ClinicFilterSelectBox from 'components/molecules/include-exclude-clinic-select-box';
import { type FC } from 'react';

import { useFilter } from './filter/use-filter';
import s from './styles.module.scss';

export const Clinics: FC = () => {
  const { updateFilter, filter } = useFilter();

  return (
    <div className={s['form-group']}>
      <ClinicFilterSelectBox
        included={filter.clinicGuidsIncluded}
        excluded={filter.clinicGuidsExcluded}
        onChange={({ included = [], excluded = [] }) => {
          updateFilter({
            clinicGuidsIncluded: included,
            clinicGuidsExcluded: excluded,
          });
        }}
      />
    </div>
  );
};
